<template>
  <div class="k-onboarding__quest-wrapper">
    <div class="k-onboarding__quest">
      <div class="k-onboarding__goal-label">Выберите цель:</div>
      <div
        :class="['k-onboarding-button k-goal-button c-pointer col-12 col-md-8 col-lg-6', {'ob-orange': goal === goal_key, 'ob-white': goal !== goal_key}]"
        @click="setGoal(goal_key)"
        :key="goal_key"
        :data-key="goal_key"
        v-for="(goal_name, goal_key) in getGoalTypes"
      >{{ goal_name }}</div>
      <div class="error-message" v-if="hasError">
        Ошибка при создании профиля.
        <br />Проверьте данные и попробуйте ещё раз
      </div>
      <div
        class="cursor-pointer"
        @click.prevent="processCreateProfile"
        :class="['k-onboarding__quest-next', { active: validGoal }]"
      >
        <span v-if="!busyState">Далее</span>
        <k-spinner v-else button/>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import dateFormat from '../utils/dateformat';
import KSpinner from '../components/TheSpinner';

export default {
  name: "OnboardingGoal",
  components: {
    KSpinner
  },
  props: {
    editProfile: Object,
  },
  data() {
    return {
      hasError: false,
      busyState: false
    };
  },
  computed: {
    ...mapGetters([
      'getGoalTypes',
    ]),
    goal: {
      get() {
        if (this.editProfile) return this.editProfile.goal;
        return this.$store.getters.getProfileGoal;
      },
      set(value) {
        if (!this.editProfile) {
          this.$store.dispatch("setProfileData", { goal: value });
        } else {
          this.editProfile.goal = value;
        }
      }
    },
    validGoal() {
      return this.goal;
    },
    currentCreatedProfile() {
      return this.$store.getters.getUserFamily.find(el => el.is_main === 't')
    }
  },
  mounted() {
    this.hasError = false;
  },
  methods: {
    ...mapActions(["loadUser", "createProfile", 'updateProfile', 'createNewProfile']),
    setGoal(goal) {
      this.goal = goal;
    },
    async processCreateProfile() {
      if (this.busyState) return;

      this.hasError = false;
      this.busyState = true;

      if (this.validGoal) {
        console.table({
          one: Boolean(this.currentCreatedProfile && !this.editProfile),
          two: Boolean(!this.editProfile && !this.currentCreatedProfile),
          three: Boolean(this.editProfile)
        })
        if (this.currentCreatedProfile && !this.editProfile) {

          const { data } = await this.updateProfile({
            id: this.currentCreatedProfile.id,
            goal: this.goal,
          })

          this.$emit('setNewProfile', data.profile);
          this.$router.push({ name: "OnboardingResult" });

        } else if (!this.editProfile && !this.currentCreatedProfile){
          
          try {
            await this.createProfile(true)
            this.$router.push({ name: "OnboardingResult" });
          } catch(err) {
            console.log('err', err)
            this.hasError = true;
          }

        } else if (this.editProfile) {
          if (this.editProfile.birth_date.includes(".")) {
            const splitDate = this.editProfile.birth_date.split(".");
            this.editProfile.birth_date = dateFormat(
              new Date(splitDate[2], splitDate[1] - 1, splitDate[0]),
              "yyyy-mm-dd"
            );
          }

          const {
            gender,
            height,
            weight,
            birth_date,
            goal,
            activity,
            id
          } = this.editProfile;

          const { data } = await this.updateProfile({
            gender,
            height,
            weight,
            birth_date,
            goal,
            activity,
            id,
          });

          this.$emit('setNewProfile', data.profile);
          this.$router.push({ name: "OnboardingResult" });
        }
      }

      this.busyState = false;
    }
  }
};
</script>

<style scoped lang="scss">
// #F68C1E
</style>
